import { DISMISS_MESSAGE, LEVEL, POP_MESSAGE, SHOW_MESSAGE } from './constants';

export const showMessage = ({ title, level, message = title, duration }) => ({
  type: SHOW_MESSAGE,
  payload: {
    title,
    message,
    duration,
    level: LEVEL[level] || LEVEL.success,
  },
});

export const dismissMessage = () => ({ type: DISMISS_MESSAGE });

export const popMessage = () => ({ type: POP_MESSAGE });
